import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySessionReplay, trackPageView } from 'utils/mixpanel';

export const PageViewTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
    applySessionReplay();
  }, [location.pathname]);
  return null;
};
